import React from 'react'

const PowerBi = (
  <div className='md:w-4/5 mx-auto py-10 text-lg'>
    <h1 className='text-2xl font-bold'>Power BI</h1>
    <div>
      <br />
      <p className='md:px-5 text-gray-500'>
        Power BI is one of the essential tools of data science integrated with business
        intelligence. Rich and insightful reports can be generated from a given dataset by using
        Power BI.
      </p>
      <br />
      <p className='md:px-5'>
        The following are the key features and usages of Power BI:
      </p>
      <br />
      <div className='md:px-5'>
        <ul className='md:px-10 list-disc pl-5 text-gray-500'>
          <li>
            It can be combined with other data science tools from Microsoft for data
            visualization.
          </li>
          <br />
          <li>
            It can help to create data analytics dashboards.
          </li>
          <br />
          <li>
            It can transform the incoherent datasets into coherent datasets.
          </li>
          <br />
          <li>
            It can develop logically consistent datasets and generate rich insights.
          </li>
          <br />
          <li>
            It facilitates making eye-catching visual reports that can be understood by
            nontechnical professionals as well.
          </li>
        </ul>
      </div>
    </div>
  </div>
)

export default PowerBi